import type { ICategoryService } from "app/common/services/categoryService";
import categoryService from "app/common/services/categoryService";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";
import type { IApiHelper } from "app/common/services/apiHelper";
import { apiHelper } from "app/common/services/apiHelper";
import { DefaultFetchService } from "app/services/fetchService";
import type { Translate } from "app/filters/i18nFilter";
import { translate } from "app/filters/i18nFilter";
import type { NavigatorType } from "single-spa/react-app/ProNavigator";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export interface IServices {
    translate: Translate;
    navigator: NavigatorType;
    categoryService: ICategoryService;
    customCategoryService: typeof UserCustomCategoryService;
    apiHelper: IApiHelper;
    fetchService: DefaultFetchService;
}

export const useMarketBuilderServices = () => {
    const services = {
        translate,
        navigator: proNavigator,
        categoryService: categoryService,
        customCategoryService: UserCustomCategoryService,
        apiHelper: apiHelper,
        fetchService: DefaultFetchService.getInstance(),
    };
    return services;
};
